import React, {
  cloneElement,
  memo,
  useEffect,
  useMemo,
  useRef,
  useState,
} from 'react';
import { debounce, differenceBy } from 'lodash-es';
import InfiniteScroll from 'react-infinite-scroll-component';
import {
  ChakraProvider,
  theme,
  Flex,
  Center,
  Image,
  Button,
  Box,
  Text,
} from '@chakra-ui/react';
import Masonry from 'react-masonry-css';
import ImageSlider from './ImageSlider';
import SelectImg from '../assets/img/select_img.svg';
import RemoveCartImg from '../assets/img/unselect_img.svg';
import ArrowIcon from '../assets/img/arrow_back.svg';
import CartIcon from '../assets/img/cart.svg';
import {
  CartPopUpCard,
  ErrorPopUpCard,
  SelectoionPopUpCard,
  ErrorToast,
} from './PopUpCards';
import { getAllCollection } from '../apis/Events';
import { useHistory } from 'react-router';
import { useStoreState, useStoreActions, useStore, action } from 'easy-peasy';
import { addPhotoToCart, deletePhotoFromCart } from '../apis/Cart';
import { verifyPayment } from '../apis/payment';
import { convertProxyObjectToObj } from '../apis/constants';
import SelectionImage from './SelectionImage';

// import UnselectImg from '../assets/img/unselect_img.svg';

const breakpointColumnsObj = {
  default: 4,
  1100: 3,
  700: 2,
  300: 2,
};

const Gallery = props => {
  const [startSelection, setStartSelection] = useState(false);
  const [saveLater, SaveLater] = useState(false);
  const [removeCart, RemoveCart] = useState(false);
  const [cartItemIndx, SetCartItemIndx] = useState();
  const [gridMt, GridMt] = useState('auto');
  const [gridMb, GridMb] = useState('14');
  const [gridZd, GridZd] = useState('908');
  const [collection, setCollection] = useState([]);
  const [eventsData, setEventData] = useState([]);
  const [errorMessage, setErrorMessage] = useState(null);
  const [errorToastMessage, setToastErrorMessage] = useState(null);
  const [errorCardShow, setErrorCardShow] = useState(false);
  const [errorToastShow, setErrorToastShow] = useState(false);
  const [filteredcollection, setFilteredCollection] = useState([]);
  const [dataSelection, setDataSelection] = useState(collection);

  const [showSelection, ShowSelection] = useState([]);
  const [cart, setCart] = useState([]);
  const [finalcart, setFinalCart] = useState([]);
  const { id } = props;
  const [isStartBuy, setisStartBuy] = useState(false);

  const [isShowAlert, setShowAlert] = useState(false);
  const [alertMessage, setAlertMessage] = useState(null);

  const [isLoadAgain, setLoadAgain] = useState(false);

  const loadMore = props.fetchMore;
  const userProfile = useStoreState(state => state.userProfile);
  const isUserLogged = useStoreState(state => state.isUserLogged);
  const eventDetails = useStoreState(state => state.eventDetails);
  const setEventDetails = useStoreActions(store => store.handleEventDetails);
  const tempCart = useStoreState(state => state.tempCart);
  const eventCollection = useStoreState(state => state.eventCollection);
  const handleInstantCheckout = useStoreActions(
    action => action.handleInstantCheckout
  );

  const handleTempCartMultiple = useStoreActions(
    action => action.handleTempCartMultiple
  );
  const handleTempCart = useStoreActions(action => action.handleTempCart);
  const handleSingleLevelTempCart = useStoreActions(
    action => action.handleSingleLevelTempCart
  );
  const resetTempCart = useStoreActions(action => action.resetTempCart);
  const resetInstantCheckout = useStoreActions(
    action => action.resetInstantCheckout
  );

  const history = useHistory();
  const loader = useRef(null);

  const handleObserver = entities => {
    const target = entities[0];
    console.log('target value');
    console.log(target);
    console.log('is target ',target.isIntersecting);
    if (target.isIntersecting) {
      loadMore();
      console.log('target calling');
    }
    
  };



  

  useEffect(() => {
   
    const options = {
      root: null,
      rootMargin: '20px',
      threshold: 1.0,
    };
    // initialize IntersectionObserver and attaching to Load More div
    const observer = new IntersectionObserver(handleObserver, options);
    console.log('loadercurrent',loader.current)
    if (loader.current) {
      observer.observe(loader.current);
    }

    setStartSelection(false);
  }, []);

  useEffect(() => {
    if(isLoadAgain)
    {
    setLoadAgain(false)
    console.log('loadagain calling',isLoadAgain);
  // loadMore();
  const options = {
    root: null,
    rootMargin: '20px',
    threshold: 1.0,
  };
  // initialize IntersectionObserver and attaching to Load More div
  const observer = new IntersectionObserver(handleObserver, options);
  console.log('loadercurrent',loader.current)
  if (loader.current) {
    observer.observe(loader.current);
  }

    setStartSelection(false);
    }
  }, [isLoadAgain]);

  

  useEffect(() => {
    console.log('ye call hua', tempCart.length);

    let item = convertProxyObjectToObj(tempCart);
    console.log('item');
    console.log(item);
    if (item.length != finalcart.length) {
      setFinalCart([]);
      setFinalCart(item);
    }
    console.log(finalcart);
  }, [tempCart]);

  useEffect(() => {
    console.log('start buy call');

    if (isStartBuy) {
      isUserLogged
        ? callPaymentGateway(false)
        : history.push({
            pathname: `${process.env.PUBLIC_URL}/login-checkout`,
            state: { isPurchaseAll: false },
          });
      setisStartBuy(false);
    }
    console.log('start buy value', isStartBuy);
  }, [isStartBuy]);

  const callPaymentGateway = buyAll => {
    console.log('tempcart length', tempCart.length);
    console.log('finalcart length', finalcart.length);

    let selectedPhotoPrice = tempCart.length
      ? tempCart.length * Number(eventDetails.per_photo_price) * 100
      : collection.length * Number(eventDetails.per_photo_price) * 100;
    let collectionPrice = Number(eventDetails.all_photos_price) * 100;
    let payingAmount = buyAll ? collectionPrice : selectedPhotoPrice;
    console.log(
      'payingAmount',
      Number(collectionPrice),
      Number(selectedPhotoPrice)
    );
    // if(payingAmount){
    const data = fetch('http://localhost:1337/local-razorpay', {
      method: 'POST',
      body: JSON.stringify({
        amount: payingAmount,
      }),
    }).then(t => t.json());

    const options = {
      key: 'rzp_live_g7QxhlM8a9lWHl',
      currency: data.currency,
      amount: payingAmount,
      name: 'Memzo API',
      description: 'Test Wallet Transaction',
      image: 'https://snapwrap.io/img/favicon.png',
      order_id: data.id,
      handler: function (response) {
        history.replace(window.location.pathname, null, ' ');
        buyPhotos(response.razorpay_payment_id, buyAll);
      },
      prefill: {
        name: '',
        email: '',
        contact: '',
      },
    };

    const paymentObject = new window.Razorpay(options);

    if (paymentObject) {
      paymentObject.open();
    }

    // }
  };
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  const buyAllPictures = buyAll => {
    const data = fetch('http://localhost:1337/local-razorpay', {
      method: 'POST',
      body: JSON.stringify({
        amount: Number(eventsData.all_photos_price) * 100,
      }),
    }).then(t => t.json());

    const orderAmount = Number(eventsData.all_photos_price) * 100;
    const options = {
      key: 'rzp_live_g7QxhlM8a9lWHl',
      currency: data.currency,
      amount: orderAmount,
      name: 'Memzo API',
      description: 'Test Wallet Transaction',
      image: 'https://snapwrap.io/img/favicon.png',
      order_id: data.id,
      handler: function (response) {
        //   alert(response.razorpay_payment_id);
        history.replace(window.location.pathname, null, ' ');
        buyPhotos(response.razorpay_payment_id, buyAll);
        //   alert(response.razorpay_order_id);
        //   alert(response.razorpay_signature);
      },
      prefill: {
        name: '',
        email: '',
        contact: '',
      },
    };

    const paymentObject = new window.Razorpay(options);

    if (paymentObject) {
      paymentObject.open();
    }
  };

  const alertBuilder = (displayState, message) => {
    setAlertMessage(message);
    setShowAlert(displayState);
  };

  const toastBuilder = (displayState, message) => {
    setToastErrorMessage(message);
    setErrorToastShow(displayState);
  };

  const checkUser = (buyAll, selectedPhotos) => {
    if (buyAll) {
      isUserLogged
        ? callPaymentGateway(buyAll)
        : history.push({
            pathname: `${process.env.PUBLIC_URL}/login-checkout`,
            state: { isPurchaseAll: buyAll },
          });
    } else {
      getSelectedPhotos();
      const getUniqueImagesList = differenceBy(
        selectedPhotos,
        convertProxyObjectToObj(tempCart),
        'image_name'
      );
      console.log('remaining selected photos', getUniqueImagesList);
      if (getUniqueImagesList.length > 0)
        handleTempCartMultiple(getUniqueImagesList);
      //  let items = tempCart.filter(item => item.isSelected);
      //  getFinalCartPhotos();
      if (
        selectedPhotos.length > 0 ||
        tempCart.length > 0 ||
        (props.Status === 'Cart' && props.collection.length > 0)
      ) {
        setisStartBuy(true);
      } else {
        // alert('Please select the image first.');
        // alertBuilder(true, 'please select image first');
        toastBuilder(true, 'please select image first');
      }
    }
  };

  const loadScript = src => {
    return new Promise(resolve => {
      const script = document.createElement('script');
      script.src = src;
      script.onload = () => {
        resolve(true);
      };
      script.onerror = () => {
        resolve(false);
      };
      document.body.appendChild(script);
    });
  };

  useEffect(() => {
    loadScript('https://checkout.razorpay.com/v1/checkout.js');
  }, []);

  useEffect(() => {
    console.log(window.location.hash);
    if (window.location.hash === '#selection-success') {
      SaveLater(true);
    } else if (window.location.hash === '#payment') {
      isUserLogged
        ? callPaymentGateway(false)
        : history.push(`${process.env.PUBLIC_URL}/login-checkout`);
    } else if (window.location.hash === '#payment-all') {
      isUserLogged
        ? callPaymentGateway(true)
        : history.push(`${process.env.PUBLIC_URL}/login-checkout`);
    } else {
      return null;
    }

   
    if (props.limitError === false) {
      
      loadMore();
    }
  }, []);

  useEffect(() => {
    console.log('PROPS', props);
    setCollection(props.collection);
    setEventData(props.event);
    // console.log(props.event);
    // setErrorMessage(props.error);
    // setToastErrorMessage(props.error);
  }, [props]);

  const istemincart = image_name => {
    const val = tempCart.findIndex(item => item.image_name === image_name);
    return val;
  };

  const getSelectedPhotos = () => {
    let items = collection.filter(item => item.isSelected);
    setCart(items);
  };

  const getFinalCartPhotos = () => {
    let items = finalcart.filter(item => item);
    console.log('getfinalcartphotos before', items);
    setFinalCart(items);
    console.log('getfinalcartphotos after', items);
  };

  const SelectBtn = id => {
    let ele = document.getElementById('gallery' + id).checked;
    // false is true and true is false in this case feature by Bharat Kumawat
    if (!ele) {
      let item = collection[id];
      item.isSelected = true;
      item.isUnSelected = false;
      handleTempCart(item);
    } else {
      let item = convertProxyObjectToObj(tempCart);
      let coll = convertProxyObjectToObj(collection);
      let filterItemFromCart = item.findIndex((image, index) => {
        return image.image_name === coll[id].image_name ? index : null; // because if its reutrn 0 then will counted false
      });

      if (Boolean(filterItemFromCart)) {
        let cloneCollection = convertProxyObjectToObj(item);
        cloneCollection.splice(filterItemFromCart - 1, 1);
        handleSingleLevelTempCart(cloneCollection);
      }
    }

    // let arr = [...collection];
    // let check = arr[id]?.isSelected;
    // arr[id].isSelected = !check;
    // console.log('ps collection');
    // console.log(collection[id]);
    // setCollection([...arr]);
    // let temcartarr=tempCart;
    // if(arr[id].isSelected)
    // {
    // handleTempCart(collection[id]);

    //  }
    //  else
    //  {
    //    console.log('id',id);
    //    console.log('id',eventCollection[id].image_name);
    //   const newList = temcartarr.filter(
    //     (item) =>

    //       item.image_name !== eventCollection[id].image_name
    //     );
    //   console.log('newList');
    //   console.log(newList);
    //   resetTempCart(newList)

    //  }
  };

  const UnselectBtn = id => {
    let arr = [...collection];
    let check = arr[id]?.isUnSelected;
    arr[id].isUnSelected = !check;
    setCollection([...arr]);

    collection.map((item, index) => {
      if (index === id) {
        if (item.isUnSelected === false) {
          console.log('RemovedData', item);
          deletePhoto(item.image_name);
        }
      }
    });
  };

  const deletePhoto = imageName => {
    deletePhotoFromCart(
      userProfile.api_key,
      eventDetails.id,
      userProfile.user_profile_id,
      imageName
    ).then(response => {
      !response.error ? removeSelectedCheckOnImages() : alert(response.message);
    });
  };

  const removeSelectedCheckOnImages = () => {
    let transData = [];
    if (Boolean(collection.length)) {
      collection.map((i, index) => {
        transData.push({ ...i, isSelected: false, isUnSelected: true });
        return null;
      });
    }
    setCollection(transData);
    //window.location.reload();
  };

  const SaveLaterBtn = () => {
    if (saveLater === false) {
      SaveLater(true);
    } else {
      SaveLater(false);
      setCart([]);
      removeSelectedCheckOnImages();
      StartSelectBtn();
      history.replace(window.location.pathname, null, ' ');
    }
  };

  const setOkay = value => {
    if (value === false) {
      SaveLater(true);
    } else {
      SaveLater(false);
    }
    if (window.location.hash === '#selection-success') {
      setTimeout(() => {
        window.location.hash = '';
        window.location = window.location.href.replace('#', '');
        window.location.reload();
      }, 500);
    }
  };

  function saveImagesToCart(selectedPhotos) {
    getSelectedPhotos(selectedPhotos);

    // setCart(cart => [...cart, selectedPhotos]);
    for (var i = 0; i < selectedPhotos.length; i++) {
      // setCart([...cart, selectedPhotos[i]]);
    }
    console.log('selected photos');
    console.log(selectedPhotos);

    handleTempCartMultiple(selectedPhotos);

    setTimeout(() => {
      if (selectedPhotos.length > 0) {
        if (isUserLogged) {
          addPhotoToCart(
            userProfile.api_key,
            eventDetails.id,
            userProfile.user_profile_id,
            selectedPhotos,
            eventDetails.per_photo_price
          ).then(response => {
            !response.error
              ? SaveLater(true)
              : alert(`Error : ${response.message}`);
          });
        } else {
          //save-selection with otp screen...
          // send otp api call
          // save -selection-otp screen
          // cart screen [login user]
          handleInstantCheckout({
            api: userProfile.api_key,
            userId: userProfile.user_profile_id,
            eventId: props.id,
            cart: selectedPhotos,
            price: eventDetails.per_photo_price,
          });

          history.push(`${process.env.PUBLIC_URL}/login-selection`);
        }
      } else {
        alert('Please select the image first!.');
      }
    }, 10);
  }

  const buyPhotos = (paymentId, buyAll) => {
    let perPricePhoto = Number(eventDetails.per_photo_price);
    let paidAmount = buyAll
      ? Number(eventDetails.all_photos_price)
      : tempCart.length * perPricePhoto;
    let imageNameCollection = tempCart.map(image => image.image_name);
    let slug = JSON.stringify({
      api: userProfile.api_key,
      userId: userProfile.user_profile_id,
      eventId: props.id,
    });
    slug = encodeURIComponent(slug);
    if (isUserLogged) {
      verifyPayment(
        userProfile.api_key,
        eventDetails.id,
        userProfile.user_profile_id,
        paymentId,
        paidAmount,
        buyAll ? 1 : 0,
        imageNameCollection
      ).then(response => {
        if (!response.error) {
          history.push(`${process.env.PUBLIC_URL}/download-photos/${slug}`);
          resetTempCart([]);
          resetInstantCheckout([]);
        } else {
          alert(`Error : ${response.message}`);
        }
      });
    } else {
      handleInstantCheckout({
        api: userProfile.api_key,
        userId: userProfile.user_profile_id,
        eventId: props.id,
      });
      history.push(`${process.env.PUBLIC_URL}/login-checkout`);
      // verifyPayment(userProfile.api_key, eventsData.id, userProfile.user_profile_id, paymentId, paidAmount, photos.length, photos)
    }
    //login -> addToCart -> event-payment -> success screen -> callPageLoad - getDownloadLink api -> email screen onEmailButton->call requestDownloadAPI
    //without login -> checkout screen -> sendOTP -> checkoutOTP screen -> make-me-gues api call [user created] -> razorpay open same as above.
  };

  const buyAllPhotosCollection = () => {
    // same as buyPhotos but do not have to calcualte prices directly fixes prices and no photos slug[name]
    //event-payment api
  };

  const gotodownload = value => {
    if (isUserLogged) {
      let slug = JSON.stringify({
        api: userProfile.api_key,
        userId: userProfile.user_profile_id,
        eventId: eventDetails.id,
      });
      slug = encodeURIComponent(slug);

      history.push(`${process.env.PUBLIC_URL}/download-photos/${slug}`);
    } else {
      history.push(`${process.env.PUBLIC_URL}/login-download`);
    }
    //window.location.reload();
  };

  const KeepItCartBtn = indx => {
    SetCartItemIndx(indx);
    removeCart === false ? RemoveCart(true) : RemoveCart(false);
  };

  const StartSelectBtn = () => {
    if (startSelection === false) {
      setStartSelection(true);
      GridMt('-27%');
      GridMb('40');
      GridZd('910');
    } else {
      setStartSelection(false);
      setDataSelection(collection);
      GridMt('auto');
      GridMb('14');
      GridZd('908');
    }
  };

  const showImageSlider = (value, index) => {
    showImage(value);
    CurrentIndx(index);

   if(value==true && index==0)
   {
    setLoadAgain(true);
   }

  };
  const [show, showImage] = useState(true);
  const [currentIndx, CurrentIndx] = useState();

  const setCardAndAlert = val => {
    setErrorCardShow(val);
    setShowAlert(val);
  };

  const setErrorToast = val => {
    setErrorToastShow(val);
  };

  useEffect(() => {
    setDataSelection(props.collection);
  }, [props.collection]);

  return (
    <ChakraProvider theme={theme}>
      {errorMessage != null ? (
        <Flex marginTop="50%">
          <Text
            textAlign="center"
            fontSize={15}
            fontWeight={400}
            color="#000000"
            width="100%"
          >
            {errorMessage ? errorMessage : null}
          </Text>
        </Flex>
      ) : null}

      {/* {startSelection && (
        <Flex
          flexDirection="column"
          bg="white"
          position="fixed"
          zIndex="2"
          top="0"
          w="100%"
          zIndex="911"
        >
          <Flex
            alignItems="center"
            justifyContent="space-between"
            boxShadow="0px 10px 40px 0px rgb(0 0 0 / 12%)"
          >
            <Box pt="4" pb="4" pl="4">
              <Image
                src={ArrowIcon}
                alt="Arrow Icon"
                w="4"
                h="4"
                onClick={StartSelectBtn}
              />
            </Box>
            <Box pt="4" pb="4" pl="6">
              <Text
                fontSize={15}
                color="#222222"
                fontWeight={700}
                textAlign={'center'}
              >
                Select photos to Buy
              </Text>
            </Box>
            <Box pt="4" pb="4" pr="4">
              <Center>
                <Flex
                  mt="-5"
                  alignItems="center"
                  justifyContent="center"
                  ml="-3"
                  w="18px"
                  h="18px"
                  bg="#FA2F45"
                  borderRadius="40"
                  position="absolute"
                >
                  <Text color="white" fontSize="11px" pt="1px" fontWeight="700">
                    {tempCart.length}
                  </Text>
                </Flex>
                <Image src={CartIcon} alt="Cart Icon" w="6" h="6" />
                <Text
                  fontSize={15}
                  fontWeight={400}
                  color="#000000"
                  pl="2"
                  pt="1"
                >
                  &#8377; {Number(eventDetails.per_photo_price*tempCart.length)}
                </Text>
              </Center>
            </Box>
          </Flex>
        </Flex>
      )} */}

      {/* ------------------------Gallery------------------------ */}
      {show && (
        <Flex flexDirection="column">
          {
            // if user click on that start selection button selection
            startSelection ? (
              <SelectionImage
                StartSelectBtn={StartSelectBtn}
                checkUser={checkUser}
                saveImagesToCart={saveImagesToCart}
                photos={dataSelection}
              />
            ) : (
              <Box
                p="5px"
                pt="0px"
                // mb={gridMb}
                // mt={gridMt}
                // bg="white"
                // zIndex={gridZd}
              >
                <Masonry
                  breakpointCols={breakpointColumnsObj}
                  className="masonry-grid"
                  columnClassName="masonry-grid_column"
                  
                >
                  {Boolean(dataSelection?.length)
                    ? dataSelection.map((item, index) => (
                        <Flex mt="2" key={index + item.image_name + 'gal'}>
                          <Image
                            onClick={() => showImageSlider(false, index)}
                            fallbackSrc="https://www.freecodecamp.org/news/content/images/2020/05/loading-animation.gif"
                            src={item.thumb_image}
                            alt="User Icon"
                          />
                        </Flex>
                      ))
                    : ''}
                </Masonry>
                      
                <div className="loading" ref={loader}>
                  {props.limitError === false ? (
                    <h2 align="center" style={{marginTop:"50%"}}>{
                      
                      (props.collection.length>0?'Load More':(props.error!=null && props.error.includes('Unfortu')?props.error:''))}</h2>
                  ) : (
                    <h2 align="center"  style={{marginTop:"50%"}}>{
                      (props.collection.length>0?'Load More':'Unfortunately, we could not find any photos with this selfie')}</h2>
                  )}
                </div>

              
              </Box>
            )
          } 

          {/* ------------------------All_Gallery------------------------ */}
          {
            props.Status === 'AllGallery' &&
            props.collection.length > 0 &&
            startSelection === false ? (
              eventDetails.is_b2b_prepaid == 1 ? (
                <Button
                  color="#FA2F45"
                  bg="#F4F4F7"
                  borderRadius="0"
                  bottom="0"
                  position="fixed"
                  h="14"
                  zIndex={gridZd}
                  className="screen-bottom-cntr"
                  boxShadow="0px 3px 16px 0px rgba(87,80,80,0.89)"
                  onClick={e => gotodownload(false)}
                >
                  Download all Photos
                </Button>
              ) : (
                <Button
                  zIndex={gridZd}
                  color="#FA2F45"
                  bg="#F4F4F7"
                  borderRadius="0"
                  bottom="0"
                  position="fixed"
                  className="screen-bottom-cntr"
                  h="14"
                  boxShadow="0px 3px 16px 0px rgba(87,80,80,0.89)"
                  onClick={StartSelectBtn}
                >
                  Select photos to Buy
                </Button>
              )
            ) : null

            // (props.Status === 'AllGallery' && props.collection.length>0   && (

            // <Flex
            //   flexDirection="column"
            //   justifyContent="center"
            //   className="screen-bottom-cntr"
            //   pt="4"
            //   pb="4"
            //   boxShadow="-3px 4px 16px 0px rgb(118 114 114 / 89%)"
            //   position="fixed"
            //   bottom="0"
            //   bg="white"
            //   zIndex={gridZd}
            // >
            //   <Text
            //     w="100%"
            //     color="#FA2F45"
            //     pt="0"
            //     pb="2"
            //     textAlign="center"
            //     fontSize="16px"
            //     fontWeight="600"
            //     borderBottom=".6px solid #e9e9e9"
            //     textDecoration="underline"
            //     onClick={() => checkUser(true)}
            //   >
            //     Buy all photos for Rs. {Number(eventsData.all_photos_price)}
            //   </Text>
            //   <Flex justifyContent="space-around" w="100%" pt="4">
            //     <Button
            //       color="#FA2F45"
            //       bg="white"
            //       h="12"
            //       borderRadius="40"
            //       border="1px solid #FA2F45"
            //       onClick={() => saveImagesToCart()}
            //     >
            //       Save for later
            //     </Button>
            //     <Button
            //       onClick={e => checkUser(false)}
            //       pl="6"
            //       pr="6"
            //       color="white"
            //       bg="#FA2F45"
            //       h="12"
            //       borderRadius="40"
            //     >
            //       Buy Photos
            //     </Button>
            //   </Flex>
            // </Flex>
            //   )
            // )
          }
        </Flex>
      )}

      {/* ------------------------Image Slider------------------------ */}
      {!show && (
        <ImageSlider
          CartItemNo={props.CartCount}
          CloseBtn={showImageSlider}
          CurrentIndex={currentIndx}
          ImageArray={collection}
          Status={props.Status}
        />
      )}

      {/* ------------------------Image Selection Card------------------------ */}

      {saveLater && <SelectoionPopUpCard SaveBtn={setOkay} />}

      {/* ------------------------Remove Item Cart------------------------ */}
      {removeCart && (
        <CartPopUpCard
          RemoveBtn={UnselectBtn}
          CartIndex={cartItemIndx}
          KeepItBtn={KeepItCartBtn}
        />
      )}

      {/* ------------------------Error Card------------------------ */}
      {errorCardShow && (
        <ErrorPopUpCard
          ErrorCardMsg={errorMessage}
          ErrorCardShow={errorCardShow}
          SetErrorCardShow={setErrorCardShow}
        />
      )}

      {/* ------------------------Error Card------------------------ */}
      {errorToastShow && (
        <ErrorToast
          ErrorCardMsg={errorToastMessage}
          ErrorCardShow={errorToastShow}
          SetErrorCardShow={setErrorToastShow}
        />
      )}

      {/* ------------------------Alert Error Card------------------------ */}
      {isShowAlert && (
        <ErrorPopUpCard
          ErrorCardMsg={alertMessage}
          ErrorCardShow={isShowAlert}
          SetErrorCardShow={setCardAndAlert}
        />
      )}
    </ChakraProvider>
  );
};
export default memo(Gallery);
